import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {DispatchRecord} from "../../../config/types";
import { AppThunk } from "../..";

const initialState:Partial<DispatchRecord>  = {

};
export const dispatchCart = createSlice({
  name: "dispatch_record",
  initialState,
  reducers: {
    update: (_state, action: PayloadAction<DispatchRecord>) => {
      return action.payload;
    },
  },
});
export const { update } = dispatchCart.actions;
export const updatedispatchCart=(data:DispatchRecord):AppThunk=> async (dispatch)=>{
  dispatch(update(data));
}
export default dispatchCart.reducer;
